import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Button
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { TitleStyled } from '../addDeviceToLocation/addDeviceToLocationStyles';
import Strings from '../../../i18n';
import { useGetDeviceByLocationMutation } from '../../../services/deviceByLocation/deviceByLocationService';
import { colors } from '../../../constants/colors';
import { DeviceByLocation } from '../../../types/Device/DeviceInterfaces';

interface SwapControllerProps {
  oldControllerId: number;
  productType?: string;
  onSave?: (newControllerId: number) => void;
  onCancel?: () => void;
}

export const SwapController = ({
  oldControllerId,
  productType,
  onSave,
  onCancel
}: SwapControllerProps) => {
  const { locationId } = useParams();
  const [getDevices, { isSuccess, data }] = useGetDeviceByLocationMutation();
  const [newControllerId, setNewControllerId] = useState<number>(0);
  const [devices, setDevices] = useState<DeviceByLocation[]>();

  const reloadTable = () => {
    if (locationId) {
      getDevices(+locationId);
    }
  };

  useEffect(() => {
    reloadTable();
  }, [locationId]);

  useEffect(() => {
    if (isSuccess && data) {
      const filteredData = data.filter(
        (lc) =>
          lc.id !== oldControllerId &&
          'productType' in lc &&
          lc.productType === productType
      );
      setDevices(filteredData);
    }
  }, [isSuccess, data]);

  const handleSave = () => {
    if (newControllerId && onSave) {
      onSave(newControllerId);
    }
  };

  return (
    <Box height="100%">
      <Box
        height="100%"
        bgcolor={colors.white}
        padding={3}
        marginTop={3}
        borderRadius={2}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Swap Controller"
              value={newControllerId}
              onChange={(e) => setNewControllerId(Number(e.target.value))}
              variant="outlined"
              size="small"
            >
              <MenuItem value={0} disabled>
                Select a controller
              </MenuItem>
              {devices?.map((device) => (
                <MenuItem key={device.id} value={device.id}>
                  {device.name || `Device ${device.id}`}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" gap={2}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={onCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSave}
                disabled={newControllerId === 0}
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
